import React, {useState} from "react";
import cabinetStyle from "./MentorCabinet.module.css";
import * as UserService from "../../api/UserService";
import * as GroupGamesService from "../../api/GroupGameService";
import * as PaymentService from "../../api/PaymentsService"
import GamesList from "./GamesList";
import StepCombinations from "./StepCombinations";
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import EarbudsRoundedIcon from '@mui/icons-material/EarbudsRounded';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import Diversity1OutlinedIcon from '@mui/icons-material/Diversity1Outlined';
import FilterNoneOutlinedIcon from '@mui/icons-material/FilterNoneOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Logout from "./Logout";
import MentorProfilePage from "./MentorProfilePage";
import MentorReferralProgramPage from "./MentorReferralProgramPage";
import MentorDocs from "./MentorDocs";
import MentorCabinetTransactions from "./MentorCabinetTransactions";
import MetaphoricCardsMentorCabinet from "../methaphoricCards/MetaphoricCardsMentorCabinet";
import SetupPage from "./SetupPage";
import MyCardsMenu from "./MyCardsMenu";
import MyCardsNewDeck from "./MyCardsNewDeck";
import MyCardsDeckEdit from "./MyCardsDeckEdit";
import MyCardsPrivateNotes from "./MyCardsPrivateNotes";
import ReactGA from "react-ga4";
import MyProfileMenu from "./MyProfileMenu";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import {useNavigate} from "react-router-dom";
import DialogComponentWithBodyChildren from "../DialogComponentWithBodyChildren";
import MentorSecuritySettings from "./MentorSecuritySettings";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import MentorCabinetGameSettings from "./MentorCabinetGameSettings";
import {useTranslation} from "react-i18next";
import InstagramWarning from "../InstagramWarning";
import TranslationSwitch from "../../translation/translationSwitch";
import {baseUrl} from "../../api/ApiUtils";

function MentorCabinet() {
    const {t} = useTranslation('translation', {keyPrefix: 'mentorCabinet'});
    const [gameState, setGameState] = useState()
    const [groupGames, setGroupGames] = useState()
    const [mentorNickName, setMentorNickName] = useState(t('defaultMentorName'))
    const [currentView, setCurrentView] = useState("game_list")
    const [selectedDeck, setSelectedDeck] = useState(undefined)
    const [currentBalance, setCurrentBalance] = useState(0)
    const [freeTier, setFreeTier] = useState(null)
    const [mentorEmail, setMentorEmail] = useState(0)
    const [gameListSelectedType, setGameListSelectedType] = useState(undefined)
    const [pendingRefBenefit, setPendingRefBenefit] = useState(false)

    const [sessionExpired, setSessionExpired] = useState(false)
    const nav = useNavigate()

    function openGameSetup() {
        setCurrentView("game_setup")
    }

    function openGamesList() {
        pullGames()
        pullGroupGames()
        pullCurrentBalance()
        setCurrentView("game_list")
    }

    function openTransactions() {
        setCurrentView("transactions")
    }

    function openMyCardsMenu() {
        setCurrentView("my_cards_menu")
    }

    function openProfileMenu() {
        setCurrentView("profile_menu")
    }

    function openMyCombinations() {
        setCurrentView("combinations")
    }


    function openReferrals() {
        ReactGA.event({
                action: "mentor action",
                category: "open referrals",
                label: "mentor cabinet"
            }
        )
        setCurrentView("referrals")
    }

    function openMetaphoricCards() {
        setCurrentView("metaphoric_cards")
    }

    function openDocs() {
        setCurrentView("mentor_docs")
    }

    function pullMentorProfileData() {
        UserService.fetchMentorProfile((response) => {
            setMentorNickName(response.nickname || t('defaultMentorName'))
            setFreeTier(response.free_tier)
            setMentorEmail(response.email)
            setPendingRefBenefit(response.pending_reference_benefit)
        }, () => {
        })
    }

    function pullGames() {
        UserService.getCreatedGamesForUser(
            setGameState,
            (response) => {
                if (response.url === baseUrl + "logout/") {
                    setSessionExpired(true)
                } else {
                    window.alert(t('couldNotFetchGamesError'))
                }

            }
        )
    }

    function pullCurrentBalance() {
        PaymentService.getCurrentBalance((jres) => {
                setCurrentBalance(jres.balance)
            }, (response) => {
                if (response.url === baseUrl + "logout/") {
                    setSessionExpired(true)
                } else {
                    window.alert(t('couldNotGetBalanceError'))
                }
            }
        )
    }

    function pullGroupGames() {
        GroupGamesService.listGroupGames(
            setGroupGames,
            (response) => {
                if (response.url === baseUrl + "logout/") {
                    setSessionExpired(true)
                } else {
                    window.alert(t('couldNotFetchGamesError'))
                }
            }
        )
    }

    useEffectOnce(() => {
        pullGames()
        pullGroupGames()
        pullMentorProfileData()
        pullCurrentBalance()
    }, []);

    return (
        <div className={cabinetStyle.layoutContainer}>
            <InstagramWarning/>
            <div className={cabinetStyle.layout}>
                <div className={cabinetStyle.mentorSideBar}>
                    <div className={cabinetStyle.languageHallo}>
                        <div className={cabinetStyle.language}>
                            <TranslationSwitch></TranslationSwitch>
                        </div>
                        <div
                            className={`${cabinetStyle.helloSection} ${cabinetStyle.sideBarText}`}>{t('helloMentor')}, {mentorNickName}</div>
                    </div>
                    <div className={`${cabinetStyle.sideBarCreateNewGame} ${cabinetStyle.sideBarText}`}
                         onClick={openGameSetup}>{t('createGame')}
                    </div>

                    <div
                        className={`${cabinetStyle.sideBarControl} ${cabinetStyle.sideBarText} ${cabinetStyle.sideBarTransactions}`}
                        onClick={openTransactions}
                        style={currentView === "transactions" ? {color: '#6610F2'} : {color: '#232735'}}
                    >
                        <MonetizationOnOutlinedIcon/>
                        <span>{t('balance')}: {currentBalance} </span>
                        {pendingRefBenefit && Object.keys(pendingRefBenefit).length !==0 &&
                            <OverlayTrigger
                                placement="right"
                                delay={{show: 400, hide: 50}}
                                overlay={<Tooltip id="button-tooltip">{t('referralBonusNotProvided')}</Tooltip>}
                            >
                                <WarningAmberIcon htmlColor={"red"}/>
                            </OverlayTrigger>
                        }
                        <div className={cabinetStyle.coinSmall}/>
                    </div>

                    <div className={`${cabinetStyle.sideBarControl} ${cabinetStyle.sideBarText}`}
                         onClick={openGamesList}
                         style={currentView === "game_list" ? {color: '#6610F2'} : {color: '#232735'}}
                    >
                        <ListAltRoundedIcon/>
                        <span>{t('games')}</span>
                    </div>
                    <div className={`${cabinetStyle.sideBarControl} ${cabinetStyle.sideBarText}`}
                         onClick={openMyCardsMenu}
                         style={["my_cards_menu", "custom_deck_new", "custom_deck_edit", "private_notes"].includes(currentView) ? {color: '#6610F2'} : {color: '#232735'}}>
                        <ReceiptLongRoundedIcon/>
                        <span>{t('myCards')}</span>
                    </div>
                    {currentView === "my_cards_menu" &&
                        <MyCardsMenu setCurrentView={setCurrentView} setSelectedDeck={setSelectedDeck}
                                     onUnathorized={() => setSessionExpired(true)}/>}
                    <div className={`${cabinetStyle.sideBarControl} ${cabinetStyle.sideBarText}`}
                         onClick={openMyCombinations}
                         style={currentView === "combinations" ? {color: '#6610F2'} : {color: '#232735'}}>
                        <EarbudsRoundedIcon/>
                        <span>{t('stepCombinations')}</span>
                    </div>
                    <div className={`${cabinetStyle.sideBarControl} ${cabinetStyle.sideBarText}`}
                         onClick={openMetaphoricCards}
                         style={currentView === "metaphoric_cards" ? {color: '#6610F2'} : {color: '#232735'}}>
                        <FilterNoneOutlinedIcon/>
                        <span>{t('metaphoricCards')}</span>
                    </div>
                    {currentView === "profile_menu" && <MyProfileMenu setCurrentView={setCurrentView}/>}
                    <div className={`${cabinetStyle.sideBarControl} ${cabinetStyle.sideBarText}`}
                         onClick={openProfileMenu}
                         style={["profile", "security", "game_settings", "profile_menu"].includes(currentView) ? {color: '#6610F2'} : {color: '#232735'}}>
                        <SettingsSuggestOutlinedIcon/>
                        <span>{t('setting')}</span>
                    </div>
                    <div className={`${cabinetStyle.sideBarControl} ${cabinetStyle.sideBarText}`}
                         onClick={openReferrals}
                         style={currentView === "referrals" ? {color: '#6610F2'} : {color: '#232735'}}>
                        <Diversity1OutlinedIcon/>
                        <span>{t('referralProgram')}</span>
                    </div>
                    <div className={`${cabinetStyle.sideBarControl} ${cabinetStyle.sideBarText}`}
                         onClick={openDocs}
                         style={currentView === "mentor_docs" ? {color: '#6610F2'} : {color: '#232735'}}>
                        <ArticleOutlinedIcon/>
                        <span>{t('documents')}</span>
                    </div>
                    <Logout/>
                </div>
                <div className={cabinetStyle.mainPage}>
                    {currentView === "game_setup" && <SetupPage callBack={openGamesList}
                                                                mentorEmail={mentorEmail}
                                                                freeTier={freeTier}
                                                                currentBalance={currentBalance}
                                                                setSelectedGameType={setGameListSelectedType}/>}
                    {currentView === "game_list" && <GamesList gameState={gameState}
                                                               updateGames={pullGames}
                                                               updateBalance={pullCurrentBalance}
                                                               groupGamesList={groupGames}
                                                               updateGroupGames={pullGroupGames}
                                                               freeTier={freeTier}
                                                               currentBalance={currentBalance}
                                                               selectedGameType={gameListSelectedType}/>}
                    {currentView === "custom_deck_new" && <MyCardsNewDeck setCurrentView={setCurrentView}/>}
                    {currentView === "custom_deck_edit" &&
                        <MyCardsDeckEdit deck_id={selectedDeck} setCurrentView={setCurrentView}/>}
                    {currentView === "private_notes" &&
                        <MyCardsPrivateNotes deck_id={selectedDeck} setCurrentView={setCurrentView}/>}
                    {currentView === "combinations" && <StepCombinations/>}
                    {currentView === "metaphoric_cards" && <MetaphoricCardsMentorCabinet/>}
                    {currentView === "profile" && <MentorProfilePage/>}
                    {currentView === "security" && <MentorSecuritySettings/>}
                    {currentView === "game_settings" && <MentorCabinetGameSettings/>}
                    {currentView === "referrals" && <MentorReferralProgramPage/>}
                    {currentView === "mentor_docs" && <MentorDocs/>}
                    {currentView === "transactions" &&
                        <MentorCabinetTransactions freeTier={freeTier} pendingRefBenefit={pendingRefBenefit}
                                                   mentorEmail={mentorEmail} onUnathorized={setSessionExpired} pullMentorData={pullMentorProfileData}/>}
                    {sessionExpired && <DialogComponentWithBodyChildren
                        onClose={() => nav("/")}
                        onConfirm={() => nav("/")}
                        title={t('authTimeOut')}
                    >
                        <span>{t('reLogin')}</span>
                    </DialogComponentWithBodyChildren>}
                </div>
            </div>
        </div>

    )
}

export default MentorCabinet